export const createUserURL = (userID, courseID) =>
  courseID ? `/${courseID}/users/${userID}` : `/users/${userID}`;

export const createUserURLTable = (userID, courseID) =>
  courseID ? `/${courseID}/manage/users/${userID}` : `/admin/users/${userID}`;
